/**
 * bak-express-checkout.js
 *
 * Intercepts clicks on links pointing to /checkout from a product detail
 * area. Adds the currently selected variant to the cart, then navigates
 * to /checkout. Used by the "Express Checkout" secondary button on PDP.
 */
(function () {
  'use strict';

  /**
   * Find the currently selected variant id within the same product-details
   * context. Falls back to the first available variant input value.
   */
  function findSelectedVariantId(scope) {
    // Look for the variant id input that Horizon's variant picker maintains
    // The active variant id is on the radio input that is :checked, with attribute data-variant-id
    const checkedRadio = scope.querySelector('variant-picker input[type="radio"][data-variant-id]:checked');
    if (checkedRadio) return checkedRadio.getAttribute('data-variant-id');

    // Fallback: the form has a hidden input named "id" with the variant id
    const hiddenId = scope.querySelector('product-form-component input[name="id"], form[action*="/cart/add"] input[name="id"]');
    if (hiddenId && hiddenId.value) return hiddenId.value;

    return null;
  }

  async function expressCheckout(link, productScope) {
    const variantId = findSelectedVariantId(productScope);
    if (!variantId) {
      console.warn('[bak-express-checkout] no variant selected, navigating directly');
      window.location.href = link.getAttribute('href') || '/checkout';
      return;
    }

    try {
      // Add to cart via Shopify AJAX API
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });
      if (!res.ok) {
        console.warn('[bak-express-checkout] cart/add failed', res.status);
      }
    } catch (e) {
      console.warn('[bak-express-checkout] add to cart error', e);
    } finally {
      window.location.href = '/checkout';
    }
  }

  function init() {
    document.addEventListener('click', function (event) {
      const target = event.target;
      if (!(target instanceof Element)) return;
      // Identify the Express Checkout button — a link with href ending in /checkout
      // located inside a .product-details container.
      const link = target.closest('a[href="/checkout"], a[href$="/checkout"]');
      if (!link) return;
      const scope = link.closest('.product-details, .product-information, .product-information__details, [data-product-id]');
      if (!scope) return;
      // Only intercept on PDPs / modal — skip if there's no variant picker around
      if (!scope.querySelector('variant-picker, product-form-component')) return;

      event.preventDefault();
      expressCheckout(link, scope);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
